import { Component, Input } from '@angular/core';
import { BaseListHeaderComponent } from '../../../list/BaseListHeader.component';

@Component({
    selector: 'admin-jobst-list-header',
    templateUrl: 'JobstListHeader.component.html'
})
export class JobstListHeaderComponent<I> extends BaseListHeaderComponent<I> {
    @Input()
    useSegment = true;
}
